<span>
  <app-header-global></app-header-global>
</span>
 
  
     

      <div class="row allcontent">
  <div [ngClass]="sidebarCollapsed  ? 'col-sm-1 custom_col_1' : 'col-sm-2'">
    <app-side-overlay-menu></app-side-overlay-menu>
  </div>
  <div [ngClass]="sidebarCollapsed ? 'col-sm-11 custom_col-sm-11' : 'col-sm-10'">


      
      <div class="main">
  
         <app-hr-page-header
            [heading]="'Employees'"
            [searchPlaceholder]="'Search'"
            [addButtonText]="'Add New Request'"
            [showExportButton]="false"
            [showFilterIcon]="false"
            (addClick)="openDialog()"
          ></app-hr-page-header>


        <div class="content">
         
          
          <div class="hr-table-container">
            <div class="table-responsive mt-3">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Contact No</th>
                    <th>Personal Email-Id</th>
                    <th style="text-align: center;">Status</th>
                    <th style="text-align: right;">Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  *ngFor="let user of users$ | async"
                  [ngClass]="{'disabled': user.status === 'user_pending'}" 
                  (click)="user.status !== 'user_pending' && openUserProfile(user,user.status)">
                    <td>{{ user.fname }}</td>
                    <td>{{ user.mobile_no }}</td>
                    <td>{{ user.email }}</td>
                    <td><span [ngClass]="getStatusClass(user.status)">
                      {{ getStatusName(user.status) }}
                    </span></td>
                    <td><div class="row">
                      <div class="col"  style="text-align: right;">
                         <p class="link"> View                       
                         </p>
                      </div>
                   </div></td>
                  </tr>
                </tbody>
            
              </table>
            </div>
          </div>
         
    
         
        </div>
      </div>
    
    </div>
  </div>
  